import Vue from 'vue'
import Vuex from 'vuex'
import userVUEX from "./modules/userVUEX.js";
import candidateVUEX from './modules/candidateVUEX.js';
import getters from "./getters";
import servicesVUEX from './modules/servicesVUEX.js';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    userVUEX,
    candidateVUEX,
    servicesVUEX
  },
  state: {
    notifOpen: false,
  },
  mutations: {
    setNotifOpen(state, value) {
      state.notifOpen = value;
    },
  },
  actions: {
  },
  getters,

})
